const places = {
  helsinki: [
    {
      name: "Istanbul Grilli"
    },
    {
      name: "Sushibar+Wine"
    },
    {
      name: "Friends & Burgers"
    },
    {
      name: "Nasty Burger"
    },
    {
      name: "Harju Döner City"
    },
    {
      name: "Pikku-Nepal"
    },
    {
      name: "Teatteri"
    },
    {
      name: "Tortilla House"
    },
    {
      name: "6k Food Market, Kamppi"
    },
    {
      name: "Hoku Kamppi"
    },
    {
      name: "Fuku"
    },
    {
      name: "Domo"
    },
    {
      name: "Koto"
    },
    {
      name: "Bastardo"
    },
    {
      name: "Beijing8"
    },
    {
      name: "That dumpling place on Pikku-Roba"
    },
    {
      name: "Sandro"
    },
    {
      name: "New Bamboo Center"
    },
    {
      name: "Bar 9"
    },
    {
      name: "Pjazza"
    },
    {
      name: "Hesburger"
    },
    {
      name: "Burger King"
    },
    {
      name: "Eerikin Pippuri"
    },
    {
      name: "Rulla"
    },
    {
      name: "Samrat"
    },
    {
      name: "Skiffer"
    },
    {
      name: "Trocadero"
    },
    {
      name: "Pobre"
    },
    {
      name: "Fafas"
    },
    {
      name: "Tamarin"
    },
    {
      name: "Thai Orchid Kamppi"
    },
    {
      name: "Levant"
    },
    {
      name: "Ravintola Bröd"
    },
    {
      name: "Kantipur"
    },
    {
      name: "The Red Koi Thai"
    },
    {
      name: "Pizzarium"
    },
    {
      name: "Shanghai Cowboy"
    },
    {
      name: "Hanko Sushi"
    },
    {
      name: "some chinese restaurant"
    },
    {
      name: "Luckiefun's"
    },
    {
      name: "Social Burgerjoint"
    },
    {
      name: "Döner Harju"
    },
    {
      name: "No Pizza"
    },
    {
      name: "Pupu"
    },
    {
      name: "Na'am Kitchen"
    },
    {
      name: "Döner Harju"
    },
    {
      name: "Bangkok 9"
    },
    {
      name: "Peace & Love"
    },
    {
      name: "Fat Ramen"
    },
    {
      name: "Sumo"
    }
  ]
};

module.exports = {
  places
};



//////////////////
// WEBPACK FOOTER
// ./lib/singles.js
// module id = /AIg
// module chunks = 1